export const MOTION_EDITOR_WORLD_OBJECT_HOTKEYS = [
  { name: 'Add object', keys: ['Shift + A'] },
  { name: 'Deselect object', keys: ['Q', 'Escape'] },
  { name: 'Move selected object', keys: ['W'] },
  { name: 'Rotate selected object', keys: ['E'] },
  { name: 'Scale selected object', keys: ['R'] },
  { name: 'Delete selected object', keys: ['Delete', 'Backspace'] },
];
